<template>
  <div class="wrapper">
      <v-expand-transition>
        <router-view />
      </v-expand-transition>
  </div>
</template>
<script>
export default {
  name: "Campaign",
  data() {
    return {

    };
  },
  beforeRouteLeave (to, from, next) {
      this.$store.dispatch('base/SET_SUB_MENU', []);
      this.$store.dispatch('base/SET_HEADER_ACTIONS', {});
      this.operationToDisplay = {};
      next();
  },
  methods: {
    
  },
  computed: {
    
  },
  mounted() {
  },
};
</script>
